import type { IconSvgObject } from './types';

const Comet02Icon: IconSvgObject = [
  ["path", { d: "M15 2L13.5 3.5M9 8L11.5 5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.4142 10.5858C22.1953 11.3668 22.1953 12.6332 21.4142 13.4142C20.6332 14.1953 19.3668 14.1953 18.5858 13.4142C17.8047 12.6332 17.8047 11.3668 18.5858 10.5858C19.3668 9.80474 20.6332 9.80474 21.4142 10.5858Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.00008 18L3.50008 12.5L7.00008 11.0002L10.0001 14.5L12.5001 12.5L15.0001 17L14.0001 19.5L7.50008 22L2.00008 18Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21.9998 2.00098L13.9998 10.001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Comet02Icon;
